import React, { useEffect } from 'react';
import { Check, ArrowLeft, Phone } from 'lucide-react';
import { AGENT } from '@/data/agent';

// Conversion page for Google Ads tracking.
// Reached via full page load after a successful Netlify Forms submission,
// so any pageview-based conversion tag fires reliably.
const ThankYou = () => {
  useEffect(() => {
    document.title = 'Thank You | Kaid Maycock — Bayleys Hibiscus Coast';
    // Keep this page out of search results
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  const firstName = new URLSearchParams(window.location.search).get('name') || '';

  return (
    <main className="min-h-screen bg-bayleys-navy text-white flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-xl bg-white text-bayleys-navy p-8 sm:p-12 animate-fade-up">
        <span className="flex items-center justify-center w-12 h-12 bg-bayleys-navy text-white mb-6">
          <Check className="w-5 h-5" strokeWidth={2.5} />
        </span>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">
          Thanks{firstName ? `, ${firstName}` : ''} — enquiry received.
        </h1>
        <p className="mt-4 text-bayleys-navy/75 text-base leading-relaxed">
          Your enquiry is on its way to Kaid. Expect a personal reply shortly —
          usually within a few hours during business days.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a
            href={AGENT.phoneHref}
            className="inline-flex items-center justify-center gap-2 bg-bayleys-navy text-white px-6 py-3.5 text-sm font-semibold tracking-wide hover:opacity-90 transition-opacity"
          >
            <Phone className="w-4 h-4" />
            Call {AGENT.phone}
          </a>
          <a
            href="/"
            className="inline-flex items-center justify-center gap-2 border border-bayleys-navy/25 px-6 py-3.5 text-sm font-semibold tracking-wide hover:border-bayleys-navy transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </a>
        </div>
      </div>
    </main>
  );
};

export default ThankYou;
